import React from "react";
import ReportPage from "./ReportPage";

export default function TaxReports() {
  return (
    <ReportPage
      title="Tax Reports"
      subtitle="PAYE tax computation report."
      endpoint="/reports/tax"
      exportName="tax"
      summaryCards={[
        { key: "total_monthly_paye", label: "Monthly PAYE", money: true },
        { key: "total_annual_pit", label: "Annual PIT", money: true },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "monthly_taxable_gross", label: "Monthly Taxable Gross" },
        { key: "annual_gross", label: "Annual Gross" },
        { key: "annual_eligible_deductions", label: "Eligible Deductions" },
        { key: "annual_rent_relief", label: "Rent Relief" },
        { key: "annual_chargeable_income", label: "Chargeable Income" },
        { key: "annual_pit", label: "Annual PIT" },
        { key: "monthly_paye", label: "Monthly PAYE" },
      ]}
    />
  );
}
